import { PRODUCT_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: PRODUCT_MNG,
  params: null,
  formatData(data) {
    const productVersion = `${data.productVersion[0]}_V${data.productVersion[1]}.${data.productVersion[2]}_${data.productVersion[3]}`
    data.productVersion = productVersion
    return data
  },
  view: {
    title: '创建产品版本',
    labelPosition: 'right',
    content: [
      {
        $id: 'productVersion',
        $type: 'sky-product-version-name',
        label: '产品版本',
        $el: {
          placeholder: '请输入产品版本',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: '产品版本'
          }
        ]
      }
    ]
  }
}
